import { useCountdown } from "@/hooks/useCountdown";
import { EVENT_DEPARTURE } from "@/config/event";

const UNITS = [
  { key: "days", label: "Dagar" },
  { key: "hours", label: "Timmar" },
  { key: "minutes", label: "Minuter" },
  { key: "seconds", label: "Sekunder" },
];

function pad(n) {
  return String(n).padStart(2, "0");
}

export const CountdownTimer = () => {
  const t = useCountdown(EVENT_DEPARTURE);

  return (
    <section
      className="w-full flex flex-col items-center"
      aria-label="Nedräkning till avgång"
      data-testid="countdown-timer"
    >
      <p className="text-[10px] md:text-xs font-bold uppercase tracking-[0.3em] text-gray-500 mb-3">
        {t.isOver ? "Vi ses ombord" : "Avgår om"}
      </p>
      <div className="flex items-stretch gap-2 md:gap-4">
        {UNITS.map((u, i) => (
          <div key={u.key} className="flex items-stretch gap-2 md:gap-4">
            <div className="flex flex-col items-center">
              <div
                className="relative bg-[#0A0A0A] border border-[#FFD700]/25 rounded-sm w-[62px] h-[64px] md:w-[88px] md:h-[92px] flex items-center justify-center overflow-hidden shadow-[0_0_25px_rgba(255,215,0,0.08)]"
                data-testid={`countdown-${u.key}`}
              >
                <div className="absolute inset-x-0 top-1/2 h-px bg-black/60" aria-hidden="true" />
                <span className="font-heading text-3xl md:text-5xl text-[#FFD700] tabular-nums leading-none drop-shadow-[0_0_10px_rgba(255,215,0,0.3)]">
                  {pad(t[u.key])}
                </span>
              </div>
              <span className="mt-2 text-[9px] md:text-[11px] font-bold uppercase tracking-widest text-gray-500">
                {u.label}
              </span>
            </div>
            {i < UNITS.length - 1 && (
              <span className="font-heading text-2xl md:text-4xl text-[#FFD700]/40 self-center pb-6 hidden sm:block">
                :
              </span>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};
